// @flow

export const DEFAULT_MAX_LENGTH = 80;
export const DEFAULT_SUFFIX = '…';

export default function smartTruncate(
  s: ?string,
  maxLength: number = DEFAULT_MAX_LENGTH,
  suffix: string = DEFAULT_SUFFIX,
) {
  let truncated;
  if (!s) {
    return '';
  } else if (s.length <= maxLength) {
    return s;
  } else if (s[maxLength - 1] !== ' ' && s[maxLength] === ' ') {
    // this mirrors logic in text_utils.smart_truncate
    truncated = s.substring(0, maxLength);
  } else {
    const truncationIndex = s.lastIndexOf(' ', maxLength);
    truncated = s.substring(0, truncationIndex);
  }

  // strip all trailing punctuation and spaces before applying the suffix
  truncated = truncated.replace(/[\- _,.<>:;+=*&@~\/\|!]*$/, '');

  return truncated + suffix;
}
